"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_router_dom_1 = require("react-router-dom");
var queryParams_1 = require("../../../common/service/queryParams");
var UrlParamTypes_1 = require("../../../common/enum/UrlParamTypes");
var useUrlDealId = function () {
    var location = react_router_dom_1.useLocation();
    var token = queryParams_1.default.getParam(UrlParamTypes_1.UrlParamTypes.TOKEN, location);
    return token;
};
exports.default = useUrlDealId;
